import React from 'react';

export default props => (
  <div className="alert alert-secondary" role="alert">
    No orders found.
  </div>
);



// WEBPACK FOOTER //
// ./src/components/orders/NoOrdersFound.js